export const InspectionLink = (inspectionId, tab) => {
  return tab ? `/inspections/${inspectionId}?tab=${tab}` : `/inspections/${inspectionId}`;
};

export const InspectionResultLink = (inspectionResultId) => {
  return `/inspection_results/${inspectionResultId}`;
};

export const InspectionSubjectLink = (inspectionSubjectId, tab) => {
  return tab
    ? `/inspection_subjects/${inspectionSubjectId}?tab=${tab}`
    : `/inspection_subjects/${inspectionSubjectId}`;
};

export const PlaceLink = (placeId, tab) => {
  return tab ? `/places/${placeId}?tab=${tab}` : `/places/${placeId}`;
};

export const PlacesLink = () => {
  return '/places';
};

export const InspectionsLink = () => {
  return '/inspections';
};

export const InspectionsCalendarLink = () => {
  return '/inspections/calendar';
};

export const DashboardLink = () => {
  return '/dashboard';
};

export const InspectionSubjectsLink = () => {
  return '/inspection_subjects';
};

export const ProfileLink = () => {
  return '/profile';
};

export const LoginLink = () => {
  return '/users/login';
};

export const RegisterLink = () => {
  return '/users/register';
};

export const ForgotPasswordLink = () => {
  return '/users/forgot_password';
};

export const TemplatesLink = () => {
  return '/templates';
};

export const TemplateLink = (templateId) => {
  return `/templates/${templateId}`;
};

export const NotificationsLink = () => {
  return '/notifications';
};

export const NotFoundLink = () => {
  return '/not-found';
};

export const SomethingWrongLink = () => {
  return '/something-wrong';
};

export const SpaceLink = (spaceId) => {
  return `/spaces/${spaceId}`;
};

export const SpaceShowLink = (tab) => {
  return tab ? `/space/show?tab=${tab}` : '/space/show';
};

export const SpaceInspectionLink = (spaceId, inspectionId) => {
  return `/spaces/${spaceId}/inspections/${inspectionId}`;
};

export const SpaceInspectionsLink = (spaceId, filter) => {
  return `/spaces/${spaceId}/inspections?filter=${filter}`;
};

export const SpaceBillingLink = () => {
  return '/space/billing';
};

export const SpaceUsersLink = () => {
  return '/space/users';
};

export const SpacesLink = () => {
  return '/spaces';
};

export const WebsiteLink = () => {
  return import.meta.env.VITE_WEBSITE_URL;
};

export const TermsLink = () => {
  return import.meta.env.VITE_WEBSITE_URL + '/terms';
};

export const PaymentTermsLink = () => {
  return import.meta.env.VITE_WEBSITE_URL + '/payment-terms';
};

export const PrivacyPolicyLink = () => {
  return import.meta.env.VITE_WEBSITE_URL + '/privacy-policy';
};

export const hardRedirect = (to) => {
  window.location.assign(to);
};
